module.exports = __webpack_public_path__ + "img/influencer_thumbnail.e367b7d8.jpg";